export default "__VITE_PUBLIC_ASSET__6a25505f__"